enum ReportsPageType {
    ALL = 'all',
    SYSTEM = 'system',
    CUSTOM = 'custom'
}

export default ReportsPageType;
